import { Injectable, OnDestroy } from '@angular/core';
import {LinkRef, Product} from "@kion/data-models";
import {Observable} from "rxjs";
import {map, take} from "rxjs/operators";
import {ProductsFacade} from "@kion/data-access/data-access-products";
import {LinkResolverService} from "@kion/cms";
import {CmsConfig} from "../config/cms.config";
import { SubSink } from 'subsink';

@Injectable({
  providedIn: 'root'
})
export class ProductUrlService implements OnDestroy {

  private readonly subSink: SubSink;

  constructor(private productsFacade: ProductsFacade, private cmsConfig: CmsConfig) {
    this.subSink = new SubSink();
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  getProductUrl(productCode: string): string | null {
    let url=null;
    this.productsFacade.loadById(productCode);
    this.subSink.sink = this.productsFacade.all$.pipe(
      take(1),
      map(
        (products: Product[]) => {
          const p = products.find(product => product.id === productCode);
          if (p) {
            const productId = p.baseProduct ? p.baseProduct : p.id;
            const productName = p.urlName;
            const fragment = p.baseProduct ? `?variant=${p.id}` : '';
            return  this.cmsConfig.routes?.productBaseRoute + `/${productId}/${productName}${fragment}`
          }
          return null;
        }
      )
    ).subscribe((e)=> url=e);
    return url;
  }

  generateUrlFromProduct(product: Product): LinkRef {
    const baseUrl = '/' + this.cmsConfig.routes?.productBaseRoute + '/';
    const productId = product.baseProduct ? product.baseProduct : product.code;
    const name = product.urlName;
    return {
      url: baseUrl + productId + '/' + name,
      queryParams: product.baseProduct ? {
        variant: product.code
      } : null
    }
  }
}
